<template>
  <div class="table_content">
    <pagination-buttons></pagination-buttons>
    <table class="table_bordered">
      <tr>
        <th>{{ $t('report.individual.answered_in') }}:</th>
        <th v-for="step in list.steps">{{ step.sanitized_title }}</th>
      </tr>
      <tr v-for="submission in list.submissions">
        <td><locale-date :date="submission.created_at"></locale-date></td>
        <td v-for="step in list.steps">
          <span v-html="parseResponses(groupedAnswers(submission.answers, step.id))"></span>
        </td>
      </tr>
    </table>
    <div class="search-list-container">
      <div
        class="klickart-loader-container"
        :class="{ 'is-visible': isLoading }"
        style="margin-top: 10px">
        <div class="klickart-loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PaginationButtons from './PaginationButtons.vue';
import LocaleDate from 'src/components/general/Date.vue';

export default {
  components: {
    PaginationButtons,
    LocaleDate,
  },
  data() {
    return {
      isLoading: false,
      debounce: null,
    };
  },
  methods: {
    parseResponses(answers) {
      if (!answers || !answers.length) {
        return '-';
      }

      if (answers.length === 1) {
        return answers[0].label;
      }

      const answerList = answers
        .map(answer => `<li>${answer.label}</li>`)
        .join('');

      return `<ul>${answerList}</ul>`;
    },
  },
  computed: mapGetters({
    list: 'reportList',
    page: 'reportPage',
    groupedAnswers: 'groupedAnswers',
  }),
};
</script>




/** WEBPACK FOOTER **
 ** List.vue?118d80f2
 **/